import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NotFound from './404'; // Adjust the import path as necessary

export const ReferenceUrl = {
    // ==== CDN ====
    softwareSupportServicesServiceDescription: "https://storage.landingzone.aviatrix.com/support/support-services/software-support-services-service-description.pdf",
    supportOfferingsDatasheet: "https://storage.landingzone.aviatrix.com/support/support-services/support-offerings-datasheet.pdf",
    taServicesDescription: "https://storage.landingzone.aviatrix.com/support/support-services/ta-services-description.pdf",
    edgeServies:"https://storage.landingzone.aviatrix.com/support/support-services/aviatrix-edge-dell-hw-troubleshooting-and-rma-process.pdf"
};

const SoftwareSupportServices = () => {
    const location = useLocation();
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pageTitle, setPageTitle] = useState('No Page');

    useEffect(() => {
        const redirectMap = {
            '/support-services/software-support-services-service-description.pdf': {
                url: ReferenceUrl.softwareSupportServicesServiceDescription,
                title: 'SS Service Descriptions - Aviatrix'
            },
            '/support-services/support-offerings-datasheet.pdf': {
                url: ReferenceUrl.supportOfferingsDatasheet,
                title: 'Support Offerings - Aviatrix'
            },
            '/support-services/ta-services-description.pdf': {
                url: ReferenceUrl.taServicesDescription,
                title: 'Trusted Advisor Services - Aviatrix'
            },
            '/support-services/aviatrix-edge-dell-hw-troubleshooting-and-rma-process.pdf': {
                url: ReferenceUrl.edgeServies,
                title: 'Aviatrix Edge - Dell Hardware Troubleshooting and RMA Process'
            }
        };

        const redirectData = redirectMap[location.pathname];
        if (redirectData) {
            setPdfUrl(redirectData.url);
            setPageTitle(redirectData.title);
        } else {
            setPdfUrl(null);
            setPageTitle('No Page');
        }
    }, [location]);

    useEffect(() => {
        document.title = pageTitle;
    }, [pageTitle]);

    console.log('pdfUrl: ', pdfUrl);

    return (
        <div style={{ height: '100vh', overflow: 'hidden' }}>
            {pdfUrl ? (
                <iframe src={pdfUrl} style={{ width: '100%', height: '100%', border: 'none' }} title="PDF Viewer" />
            ) : (
                <NotFound />
            )}
        </div>
    );
};

export default SoftwareSupportServices;